import axios from "axios";
import baseURL from "../configs/api";

export const getAvailableVehiclesByVehicleClassId = (vehicleClassId: number, tenantId: string) => {
    return getFetch(`vehicles/GetAvailableVehiclesByVehicleClassId/${vehicleClassId}`, tenantId);
}

export const getAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate = (vehicleClassId: number, pickupDateTime: string, returnDateTime: string, tenantId: string) => {
    return getFetch(`vehicles/GetAvailableVehiclesByVehicleClassIdAndByPickupDateAndReturnDate/${vehicleClassId},${pickupDateTime},${returnDateTime}`, tenantId);
}

export const getVehicle = (primaryKey: number, tenantId: string) => {
    return getFetch(`vehicles/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}